import { useMemo, useRef, useState } from "react";

export const useInputValue = <V,>(props: { value?: V; defaultValue?: V }) => {
  const [_value, setValue] = useState(
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    props.defaultValue === undefined ? props.value : props.defaultValue,
  );

  const isControlled = useRef(
    Object.prototype.hasOwnProperty.call(props, "value"),
  );

  const value = useMemo(() => {
    // eslint-disable-next-line react-hooks/refs
    if (isControlled.current === false) {
      return _value;
    }
    return _value === props.value ? _value : props.value;
  }, [_value, props.value]);

  // eslint-disable-next-line react-hooks/refs
  return [value, setValue, isControlled.current] as const;
};
